import { render, staticRenderFns } from "./AttachMobile.vue?vue&type=template&id=3c83f304&v-on-clickaway=cancel&"
import script from "./AttachMobile.vue?vue&type=script&lang=ts&"
export * from "./AttachMobile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports